package com.fantasytenis.shared.data.admin.dto

import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

/**
 * Platform configuration data.
 */
@Serializable
data class PlatformConfigDto(
    @SerialName("showPaidGames")
    val showPaidGames: Boolean = false
)

/**
 * Request to update platform configuration.
 */
@Serializable
data class UpdatePlatformConfigRequest(
    @SerialName("showPaidGames")
    val showPaidGames: Boolean
)
